
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FormData } from "./types";

interface Props {
  name?: string;
  setFormData: (data: FormData) => void;
  formData: FormData;
}

const EditUserNameInput = ({ name, setFormData, formData }: Props) => (
  <div className="grid gap-2">
    <Label htmlFor="name">Full Name</Label>
    <Input
      id="name"
      value={formData.name || ""}
      onChange={e => setFormData({ ...formData, name: e.target.value })}
      placeholder="Name"
    />
  </div>
);

export default EditUserNameInput;
